/** Copy of the top bar's help menu. */
export const HELP_MENU_COPY = {
  trigger: "Help and shortcuts",
  menu: "Help",
  soon: "Coming soon",
  shortcuts: "Keyboard shortcuts",
  voice: "Voice commands",
  whatsNew: "What\u2019s new",
  docs: "Docs and tutorials",
  liveChat: "Live chat",
  feedback: "Send feedback",
  support: "Email us",
} as const;
